define('constants/liveReceptionistQueueHoldSettingConstants',[], function() {
    return {
        Unknown: "0",
        HoldMusic: "1",
        Ringing: "2"
    };
});
